import type { PhoneNumberType } from 'google-libphonenumber';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isValidPhoneNumber = (phoneNumber: string, country = 'FR'): boolean => {
    try {
        const parsedNumber = phoneUtil.parse(phoneNumber, country);
        return phoneUtil.isValidNumber(parsedNumber);
    } catch {
        return false;
    }
};

export const isValidPhoneNumberForType = (
    phoneNumber: string,
    country: string,
    expectedType?: PhoneNumberType
): boolean => {
    try {
        const parsedNumber = phoneUtil.parse(phoneNumber, country);
        if (!phoneUtil.isValidNumber(parsedNumber)) {
            return false;
        }
        if (expectedType !== undefined) {
            const numberType = phoneUtil.getNumberType(parsedNumber);
            return numberType === expectedType;
        }
        return true;
    } catch {
        return false;
    }
};

export const formatPhoneNumberDigits = (phoneNumber: string, country: string = 'FR'): string | null => {
    try {
        const parsedNumber = phoneUtil.parse(phoneNumber, country);
        if (phoneUtil.isValidNumber(parsedNumber)) {
            let nationalNumber = String(parsedNumber.getNationalNumber());
            // Préserver le zéro initial pour l'Italie et le Vatican
            if (parsedNumber.hasItalianLeadingZero()) {
                nationalNumber = `0${nationalNumber}`;
            }
            return nationalNumber || null;
        } else {
            console.error('Invalid phone number', parsedNumber);
        }
        return null;
    } catch {
        return null;
    }
};
